import type { DynamicInvoiceMeasurementChartMeter } from '@vy/api-definition';
import { isEmptyArray, isNullOrUndefined } from '@vy/utils';

export const filterMeterDataByPeriod = (
  meterData: DynamicInvoiceMeasurementChartMeter,
  selectedPeriodRange: { from: Date; to: Date } | undefined,
): DynamicInvoiceMeasurementChartMeter => {
  if (isNullOrUndefined(selectedPeriodRange)) {
    return meterData;
  }

  const fromTimestamp = new Date(selectedPeriodRange.from).getTime();
  const toTimestamp = new Date(selectedPeriodRange.to).getTime();

  const meterIds = Object.keys(meterData);
  const filtered: DynamicInvoiceMeasurementChartMeter = {};

  for (const meterId of meterIds) {
    const meterTimestamps = meterData[meterId];
    const filteredTimestamps: Record<string, { totalUnits: number; totalPrice: number }> = {};

    for (const [timestamp, value] of Object.entries(meterTimestamps)) {
      const ts = parseInt(timestamp);

      if (ts >= fromTimestamp && ts <= toTimestamp) {
        filteredTimestamps[timestamp] = value;
      }
    }

    if (!isEmptyArray(Object.keys(filteredTimestamps))) {
      filtered[meterId] = filteredTimestamps;
    }
  }

  return filtered;
};

